import React, { useEffect, useState } from 'react';
import CampaignClientManagementModal from '../../dashboard/components/modal/CampaignClientManagementModal';
import { iManageCards } from './dto/IManageCards';
import { InfluencersCard } from './InfluencersCard';
import { ClientsCard } from './ClientsCard';
import { CampaignDashboardService } from '../../dashboard/service';
import { ErrorToast, SuccessToast } from '../../../../../utils/toasters';
import { ICampaignManagement } from '../../dashboard/components/dto/ICampaignManagement';
import { useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import { hasAccessRights } from '../../../../../shared/functions/Functions';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';
import { IRescheduleNotify } from '../../../../influencer/planner/dto/IPlanner';
import { ManageService } from '../service';
import { RescheduleCard } from './RescheduleCard';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import LinkToPublicCard from '../../briefing/components/shared/LinkToPublicCard';
import { manageBrand } from '../../../../../store/brand/manageBrandSlice';
import { ConfirmationModal } from '../../../../../shared/components/modal/ConfirmationModal';
import { useTranslation } from 'react-i18next';

export const ManageCards = ({
    listOfInfluencers,
    influencersInfoData,
    platformDropdownList,
    filterParams,
    handleChangeParams,
    setNewEvent,
    setShowModal,
    updateFeedbackLoop,
    skipReporting,
    totalPages,
    influecersPagination,
    handlePagination,
    setFilterPlannerStatus,
    setTriggerUpdate,
}: iManageCards) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [managementInfo, setManagementInfo] = useState<ICampaignManagement>();
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [updateManagement, setUpdateManagement] = useState(false);
    const [rescheduleNotify, setRescheduleNotify] = useState<IRescheduleNotify[]>([]);
    const [updateInfluencers, setUpdateInfluencers] = useState(false);
    const { id } = useParams<keyof IParams>();
    const campaignId = sessionStorage.getItem('activeCampaignId');
    const { triggerRescheduleList } = useSelector((state: IAllStates) => state.manageBrand);
    const uuid = useSelector((state: IAllStates) => state.selectedCampaign.campaign?.uuid);
    const isManageShared = useSelector((state: IAllStates) => state.auth.user.company?.isManageShared);

    const [isApproveEvent, setIsApproveEvent] = useState(false);
    const [eventId, setEventId] = useState<number>();
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        CampaignDashboardService.getManagementData(id)
            .then(data => {
                setManagementInfo(data);
            })
            .catch(error => ErrorToast(error));
    }, [id, updateManagement]);

    const handleOpenModal = () => {
        setIsModalOpened(true);
    };
    const closeModal = () => {
        setIsModalOpened(false);
        setUpdateManagement(prevState => !prevState);
    };

    useEffect(() => {
        ManageService.getRescheduleNotify(Number(campaignId)).then(response => {
            setRescheduleNotify(response);
        });
    }, [campaignId, triggerRescheduleList]);

    const approveOrDeclineRescheduleRequest = async () => {
        const service = isApproveEvent
            ? ManageService.approveRescheduleRequest(eventId)
            : ManageService.declineRescheduleRequest(eventId);
        await service
            .then(response => {
                if (response) {
                    dispatch(manageBrand.actions.setTriggerRescheduleList(!triggerRescheduleList));
                    setTriggerUpdate(prevState => !prevState);
                    SuccessToast(
                        t(
                            isApproveEvent
                                ? 'general.toasts.successRescheduled'
                                : 'brand.campaign.manage.declined_request_date'
                        )
                    );
                }
            })
            .catch(err => ErrorToast(err));
    };

    const openConfirmationModalAction = (eventId: number, isApproveAction: boolean) => {
        setEventId(eventId);
        setIsApproveEvent(isApproveAction);
        setShowConfirmModal(true);
    };

    return (
        <>
            <ConfirmationModal
                title={t(
                    `influencer.planner.${
                        isApproveEvent ? 'confirm_approve_event_title' : 'confirm_decline_event_title'
                    }`
                )}
                description={t(
                    `influencer.planner.${isApproveEvent ? 'confirm_approve_event' : 'confirm_decline_event'}`
                )}
                show={showConfirmModal}
                closeModal={() => {
                    setShowConfirmModal(false);
                }}
                action={approveOrDeclineRescheduleRequest}
            />

            {isManageShared && <LinkToPublicCard uuid={uuid} route="manage" classes="mb-3" />}
            {rescheduleNotify.map(item => (
                <RescheduleCard key={item?.id} rescheduleData={item} openModalActions={openConfirmationModalAction} />
            ))}
            <InfluencersCard
                influecersPagination={influecersPagination}
                handlePagination={handlePagination}
                listOfInfluencers={listOfInfluencers}
                influencersInfoData={influencersInfoData}
                platformDropdownList={platformDropdownList}
                filterParams={filterParams}
                setFilterPlannerStatus={setFilterPlannerStatus}
                handleChangeParams={handleChangeParams}
                setNewEvent={setNewEvent}
                setShowModal={setShowModal}
                updateFeedbackLoop={updateFeedbackLoop}
                skipReporting={skipReporting}
                totalPages={totalPages}
                setTriggerUpdate={setTriggerUpdate}
            />
            {hasAccessRights(AccessRightEnum.CAN_VIEW_OPTIONS) && (
                <div className="mt-3">
                    <ClientsCard managementInfo={managementInfo} handleOpenModal={handleOpenModal} />
                </div>
            )}
            <CampaignClientManagementModal
                isSupplier={managementInfo?.isSupplier}
                show={isModalOpened}
                onClose={closeModal}
            />
        </>
    );
};
